import apiService from '../Api'
import { CommercialConsultant, CommercialConsultantInput, PanelUser, SelectCommercialConsultant } from './types'

export class CommercialConsultantService {
  async list(): Promise<CommercialConsultant[]> {
    return apiService.get('/commercial-consultant').then((res) => res.data)
  }

  // Contas do painel disponíveis para vincular a um consultor (ABRA-140).
  async listUsers(): Promise<PanelUser[]> {
    return apiService.get('/commercial-consultant/users').then((res) => res.data)
  }

  // Lista enxuta para selects fora da tela de consultores (ex.: comissão do cupom).
  async listForSelect(): Promise<SelectCommercialConsultant[]> {
    return apiService.get('/commercial-consultant/select').then((res) => res.data)
  }

  async get(id: number): Promise<CommercialConsultant> {
    return apiService.get(`/commercial-consultant/${id}`).then((res) => res.data)
  }

  async create(data: CommercialConsultantInput): Promise<CommercialConsultant> {
    return apiService.post('/commercial-consultant', data).then((res) => res.data)
  }

  async update(id: number, data: CommercialConsultantInput): Promise<CommercialConsultant> {
    return apiService.put(`/commercial-consultant/${id}`, data).then((res) => res.data)
  }

  async updateEnabled(id: number, enabled: boolean): Promise<CommercialConsultant> {
    return apiService.put(`/commercial-consultant/${id}/enabled`, { enabled }).then((res) => res.data)
  }

  async updateShowOnForms(id: number, show_on_forms: boolean): Promise<CommercialConsultant> {
    return apiService.put(`/commercial-consultant/${id}/show-on-forms`, { show_on_forms }).then((res) => res.data)
  }

  async delete(id: number): Promise<void> {
    return apiService.delete(`/commercial-consultant/${id}`)
  }
}
